/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const SectionWrapper = (props) => {
    
    const { children } = props || {};

    return (
        <main id='simplicity-layout-content-container'>
            {children}
        </main>
    );
};

export { SectionWrapper };
